export * from './sentry'

export const ApiBaseUrl = process.env.REACT_APP_API_URL

export const NetworkFee = 0.000001

export const BBA_DALTON_UNIT = 1000000000

export const formatNumber = (num: number, maximumFractionDigits = 2) => {
	return new Intl.NumberFormat('en-US', {
		maximumFractionDigits
	}).format(num)
}

export function toBBA(daltons: number | bigint): number {
	if (typeof daltons === 'number') {
		return daltons / BBA_DALTON_UNIT
	}
}

export function toBalanceString(daltons: number | bigint, maximumFractionDigits: number = 9): string {
	const amount = toBBA(daltons)
	return new Intl.NumberFormat('en-US', { maximumFractionDigits }).format(amount)
}

export function toFiatString(daltons: number | bigint, currency: string = 'USD', maximumFractionDigits: number = 2) {
	const amount = toBBA(daltons)
	return new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency,
		maximumFractionDigits
	}).format(amount)
}
